import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../api/apiClient";
import {
  fetchIrrigationTypesFailure,
  fetchIrrigationTypesStart,
  fetchIrrigationTypesSuccess,
} from "../../store/features/irrigationTypes/irrigationTypesSlice";

const URL = buildApiUrl("/api/v1/irrigation_system/irrigation_system/");

const getIrrigationTypesApi = async (accessToken, search = "") => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        search: search || null,
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchIrrigationTypesSaga(action) {
  try {
    const { accessToken, search } = action.payload;
    const irrigationTypesData = yield call(
      getIrrigationTypesApi,
      accessToken,
      search
    );
    yield put(fetchIrrigationTypesSuccess(irrigationTypesData));
  } catch (error) {
    yield put(fetchIrrigationTypesFailure(error.message));
  }
}

export default function* irrigationTypesSaga() {
  yield takeLatest(fetchIrrigationTypesStart.type, fetchIrrigationTypesSaga);
}
